import React from "react";
import { ClassNameProps, Grid, Heading, makeClassName, Modal, ModalProps, StyleProps } from "@hex-insights/core";
import { HomeRoomSectionFilterInput, useHomeRoomSectionListQuery } from "../../../../Utilities";
import { HomeRoomSectionLink } from "../../../Links";
import { HomeRoomSectionCardProps, HomeRoomSectionSimpleCard } from "../Card";
import styles from "./styles.module.css";

export type ControlledHomeRoomSectionsListModalProps = Omit<
	HomeRoomSectionsListModalProps,
	"isLoading" | "homeRoomSections"
> & {
	filters?: HomeRoomSectionFilterInput;
};

export function ControlledHomeRoomSectionsListModal({ filters, ...props }: ControlledHomeRoomSectionsListModalProps) {
	const { loading, data } = useHomeRoomSectionListQuery({ variables: { filters } });
	const homeRoomSections = React.useMemo(() => data?.homeRoomSectionConnection.edges.map((e) => e.node), [data]);

	// TODO search + filter

	return <HomeRoomSectionsListModal isLoading={loading} homeRoomSections={homeRoomSections} {...props} />;
}

export type HomeRoomSectionsListModalProps = Pick<ModalProps, "ifRef" | "onClose"> & {
	heading?: JSX.Element | string;
	isLoading?: boolean;
	homeRoomSections: HomeRoomSectionCardProps["homeRoomSection"][] | null | undefined;
} & Partial<ClassNameProps & StyleProps>;

export function HomeRoomSectionsListModal({
	heading = "Home Room Sections",
	homeRoomSections,
	ifRef,
	onClose,
	className,
	style,
}: HomeRoomSectionsListModalProps) {
	return (
		<Modal
			ifRef={ifRef}
			onClose={onClose}
			className={makeClassName(styles["home-room-sections-list-modal"], className)}
			style={style}
		>
			<Modal.Header>
				<Heading.H2 noMargin>{heading}</Heading.H2>
			</Modal.Header>
			<Modal.Body>
				<Grid tracks={2} gap="1rem">
					{homeRoomSections?.map((homeRoomSection) => (
						<HomeRoomSectionLink
							key={homeRoomSection.id}
							instance={homeRoomSection}
							className="link--no-text-decoration"
						>
							<HomeRoomSectionSimpleCard homeRoomSection={homeRoomSection} />
						</HomeRoomSectionLink>
					))}
				</Grid>
			</Modal.Body>
		</Modal>
	);
}
